const locale = {
	// #region Group fields
	DETAILS_GROUPS_FIELD_TITLE: 'Title',
	DETAILS_GROUPS_FIELD_WARNING: 'Warning',
	DETAILS_GROUPS_FIELD_BLOCKED: 'Blocked',
	DETAILS_GROUPS_FIELD_TAGS: 'Tags',
	DETAILS_GROUPS_FIELD_USER: 'User',
	// #endregion

	GROUPS_USERS_IS_MANAGER: 'Manager',
	VIEW_ITEM_BUTTON_GROUP_SET_MANAGER: 'Set as manager',

	DIALOG_GROUP_ADD_USER_TITLE: 'Choose the User to add',
	USER_ALREADY_IN_GROUP_ERROR: 'The User is already in this Group'
};

export default locale;
